import React from 'react';
import autobind from 'autobind-decorator';
import { connect } from 'react-redux';

import { PureComponent, Page } from 'core/components';
import { withLocale } from 'core/decorators';
import { ViewProfile, Login } from 'content/components';
import { Login as LoginReducer, profile } from 'core/module/operations';
import { getCart } from 'content/pages/Cart/Module';

import translations from './i18n';

class ViewProfilePage extends PureComponent {
  constructor(props) {
    super(props);

    const view = this.$f7.views.get('#view-profile')
    this.router = view && view.router

    this.state = {
      loading: true,
      items: []
    };

    this.props.translator.addModuleResource('viewProfile', translations);
  };

  handleSubmit(model) {
    this.$f7.dialog.preloader('در حال ارسال اطلاعات');

    this.props.LoginReducer(model.username, model.password, true)
      .then(r => {
        this.props.profile()
        this.props.getCart({ store: 2 })
      })
      .catch(e => {
        switch (e.response.status) {
          case 400:
            return this.$f7.dialog.alert('نام کاربری یا رمز عبور اشتباه می باشد', 'خطا');
          case 404:
            return this.$f7.dialog.confirm('این شماره در سیستم موجود نیست.<br/>شما برای خرید از فروشگاه اینترنتی باید در این سامانه ثبت نام کنید.<br/>نام کاربری یا کلمه عبور خود را کنترل کنید یا به بخش ثبت نام وارد شوید.', 'خطا', () => this.gotoSignup(model))
          // return this.$f7.dialog.alert('این شماره در سیستم موجود نیست.<br/>شما برای خرید از فروشگاه اینترنتی باید در این سامانه ثبت نام کنید.<br/>نام کاربری یا کلمه عبور خود را کنترل کنید یا به بخش ثبت نام وارد شوید.', 'خطا');
          default:
            return this.$f7.dialog.alert('نام کاربری یا رمز عبور اشتباه می باشد', 'خطا');
        }
      })
      .finally(r => {
        this.$f7.dialog.close()
      })
  }

  gotoSignup(model) {
    // this.router = this.$f7.views.current && this.$f7.views.current.router
    // console.log(this.router.history)
    // this.props.navigate.navigate('/register')
    // console.log(model)
    this.router && this.router.navigate('/register', { props: { phone: model.username } })
  }

  forget() {
    // this.props.navigate.navigate('/forget_password')
    this.router && this.router.navigate('/forget_password')
  }

  /**
   * handle loading
   * @param {Boolian} loading 
   */
  loading(loading = false) {
    this.setState((prevState, props) => {
      return { loading: loading }
    });
  };

  render() {
    const { authorized, showClose, popupClose, closePopupClassName, view } = this.props;

    return (
      <Page
        pageName="viewProfile"
        showBack={false}
        showClose={showClose}
        closePopup={popupClose}
        closePopupClassName={closePopupClassName}
      >
        {authorized ?
          <ViewProfile />
          :
          <Login
            submit={this.handleSubmit}
            forget={this.forget}
            view={view}
          />
        }
      </Page>
    );
  };
};

export default connect(
  state => ({
    cart: state.Cart.cart,
    authorized: state.General.authorized,
  }),
  {
    LoginReducer,
    profile,
    getCart
  }
)(withLocale('viewProfile')(autobind(ViewProfilePage)));
